import { isRichTextEmpty } from '~/common/utils/richText';

const validateRichText = (rule, value: string) => (value ? !isRichTextEmpty(value) : true);

export default validateRichText;
